
const apiUrl = process.env.REACT_APP_API_URL || 'https://api.onebrokerage.org/';

const environment = {
  api: apiUrl,
  contractId: process.env.REACT_APP_CONTRACT_ID || '',
  weeklyId: process.env.REACT_APP_WEEKLY_ID || '',
  imageapi: apiUrl,
  map_api_key: process.env.REACT_APP_GOOGLE_MAP_KEY || '',
  planTypeId: process.env.REACT_APP_PLAN_TYPE_ID || '',
  userRoleId: process.env.REACT_APP_USER_ROLE_ID || '',
  adminRoleId: process.env.REACT_APP_ADMIN_ROLE_ID || '',
  googleAPIKey: process.env.REACT_APP_GOOGLE_MAP_KEY || '',
  rfpsId: process.env.REACT_APP_RFPS_ID || '',
  uspsId: process.env.REACT_APP_USPS_ID || '',
  prebooksId: process.env.REACT_APP_PREBOOKS_ID || '',
};
export default environment;
